export default {"src":"/_next/static/media/water-reduction.7957ed03.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};